import { useCallback, useState } from 'react';
// only allows setting valid state, validated by a given yupSchema
export function useValidatedState(initialState, yupSchema) {
    const [value, setValue] = useState(initialState);
    const setValueValidated = useCallback((val) => {
        if (yupSchema) {
            try {
                if (yupSchema.isValidSync(val)) {
                    setValue(val);
                }
            }
            catch (error) {
                // TODO: should we handle errors sometimes
                console.error('YUP SCHEMA ERROR: ', error);
            }
        }
        else {
            setValue(val);
        }
    }, [setValue, yupSchema]);
    return [value, setValueValidated];
}
